<template>
  <div class="bases-list">
    <ul class="bases-list-header">
      <li>基地名称</li>
      <li>依托单位</li>
      <li>批准时间</li>
      <li>研究领域</li>
    </ul>
    <div class="base-item" v-for="(base, index) in basesData" :key="index">
      <p>{{ base.baseName }}</p>
      <p>{{ base.orgName }} | {{ base.department }}</p>
      <p>{{ base.year || '-' }}</p>
      <p>{{ base.fields || '-' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'orgScholarsList',
  props: ['basesData'],
};
</script>

<style scoped lang="less">
.bases-list {
  .bases-list-header {
    display: flex;
    list-style: none;
    height: 40px;
    line-height: 40px;
    background-color: #F9FAFB;
    border-bottom: 1px solid #EAE9E9;
    margin-top: 12px;

    li {
      box-sizing: border-box;
      padding: 0 10px;
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      border-right: 1px solid #EEEEEE;
      text-align: center;

      &:nth-of-type(1) {
        width: 300px;
      }
      &:nth-of-type(2) {
        width: 280px;
      }
      &:nth-of-type(3) {
        width: 100px;
      }
      &:nth-of-type(4){
        width: 280px;
      }
    }
  }

  .base-item {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #EEEEEE;
    color: #333333;

    > p {
      box-sizing: border-box;
      padding: 10px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
      font-size: 16px;

      &:nth-of-type(1) {
        width: 300px;
      }
      &:nth-of-type(2) {
        width: 280px;
      }
      &:nth-of-type(3) {
        width: 100px;
        text-align: center;
      }
      &:nth-of-type(4){
        width: 280px;
        text-align: center;
      }
    }
  }
}

</style>
